var initialState = {
    isOpen: false
};

export default function modal(state = initialState, action) {
    switch (action.type) {
        case 'OPEN_MOBILE_NAV':
            return {
                ...state,
                isOpen: true,
                type: action.navType,
                component: action.component,
                props: action.props,
            };
        case 'CLOSE_MOBILE_NAV':
            // api mark all as read
            return {
                ...state,
                isOpen: false
            };
        default:
            return state;
    }
}

export function closeMobileNav() {
    return {
        type: 'CLOSE_MOBILE_NAV'
    };
}

export function openMobileNav(navType, component, props = {}) {
    return {
        type: 'OPEN_MOBILE_NAV',
        component,
        navType,
        props
    };
}




// WEBPACK FOOTER //
// ./app/reducers/mobileNav.js